export enum AutopostBills {
  ALWAYS = 'always',
  ASK = 'ask',
  NEVER = 'never',
}

export function castAutopostBillsEnum(value: AutopostBills): string {
  switch (value) {
    case AutopostBills.ALWAYS:
      return 'CUSTOMERS.AUTOPOST_BILLS_ALWAYS';
    case AutopostBills.ASK:
      return 'CUSTOMERS.AUTOPOST_BILLS_ASK';
    case AutopostBills.NEVER:
      return 'CUSTOMERS.AUTOPOST_BILLS_NEVER';
  }
}
